import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { TenantTokenUsageView } from "./TenantTokenUsageView";
import { TenantTokenUsageViewStore } from "../../store/TenantTokenUsageViewStore";
import { useStore } from "../../../../hooks";

export const TenantTokenUsageViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/tenantTokenUsage/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new TenantTokenUsageViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <TenantTokenUsageView tenantTokenUsageViewStore={store} />
      </PageLayout>
    </div>
  );
});
